import MainExperience from "../MainExperience/MainExperience";
import MainEnvironment from "./MainEnvironment";
import { Mesh, BoxGeometry, MeshStandardMaterial } from "three";
import MainFloor from "./MainFloor";
import Model from "./Model";
import Water from "./Water";
import NightSky from "./NightSky";

export default class World {
  constructor() {
    this.experience = new MainExperience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;

    // this.test();

    this.resources.on("ready", () => {
      // this.floor = new MainFloor();
      this.water = new Water();
      this.nightSky = new NightSky();
      // this.model = new Model();
      this.environment = new MainEnvironment();
    });
  }

  test() {
    const cube = new Mesh(
      new BoxGeometry(1, 1, 1),
      new MeshStandardMaterial({ color: 0xff0000, wireframe: false })
    );
    cube.position.set(-1, 2.5, 2.5);
    cube.castShadow = true;
    this.scene.add(cube);
  }

  update() {
    if (this.model) {
      this.model.update();
    }
  }
}
